import { render, staticRenderFns } from "./d-book-user-review-author.vue?vue&type=template&id=a534b322&scoped=true&"
import script from "./d-book-user-review-author.vue?vue&type=script&lang=js&"
export * from "./d-book-user-review-author.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-review-author.vue?vue&type=style&index=0&id=a534b322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a534b322",
  null
  
)

export default component.exports